/**
 * Miniature colore sulla scheda prodotto (snippets/card-color-thumbs.liquid).
 * Solo con mouse: al passaggio su una miniatura la prima foto della scheda mostra quel colore,
 * all'uscita torna quella originale. Su touch il tap apre direttamente il prodotto nel colore scelto.
 */
class CardColorThumbs extends HTMLElement {
  connectedCallback() {
    if (!window.matchMedia('(hover: hover)').matches) return;

    this.addEventListener('pointerover', this.#onOver);
    this.addEventListener('pointerleave', this.#restore);
  }

  disconnectedCallback() {
    this.removeEventListener('pointerover', this.#onOver);
    this.removeEventListener('pointerleave', this.#restore);
  }

  /** Foto visibile in questo momento (con "seconda foto al passaggio" può essere la seconda slide). */
  get #visibleImage() {
    const gallery = this.closest('.card-gallery');
    return /** @type {HTMLImageElement | null} */ (
      gallery?.querySelector('slideshow-slide[aria-hidden="false"] img') ??
        gallery?.querySelector('slideshow-slide:not([hidden]) img') ??
        null
    );
  }

  /** @type {{ image: HTMLImageElement, src: string, srcset: string } | null} */
  #original = null;

  #onOver = (/** @type {PointerEvent} */ event) => {
    const item = /** @type {HTMLElement | null} */ (
      event.target instanceof Element ? event.target.closest('.card-color-thumbs__item') : null
    );
    if (!item || !item.dataset.imageSrc) return;

    const image = this.#original?.image ?? this.#visibleImage;
    if (!image) return;

    if (!this.#original) this.#original = { image, src: image.src, srcset: image.srcset };
    image.srcset = item.dataset.imageSrcset || '';
    image.src = item.dataset.imageSrc;
  };

  #restore = () => {
    if (!this.#original) return;

    const { image, src, srcset } = this.#original;
    image.srcset = srcset;
    image.src = src;
    this.#original = null;
  };
}

if (!customElements.get('card-color-thumbs')) {
  customElements.define('card-color-thumbs', CardColorThumbs);
}
